import React, { useState } from 'react';
import Button from './Button';


import Loader from "./Misc/Loader";


const Form = ({ labels, blocks, langId, scanResult, rapport, questions }) => {

  var path = 'https://admin.echo-cms.be/api/';
  //var path = "https://echo-cms.ddev.site/api/";
  const [info, setInfo] = useState("dag (voornaam), zonet vulde ik een zelftest in rond werkdruk- en tijdbeheer en kreeg daar interessante en praktische tips. Ik dacht: misschien wel iets voor jou, dus hierbij de link! Gegroet!");
  const [name, setName] = useState("");
  const [submit, setSubmit] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [emailOther, setEmailOther] = useState("");

  const validEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  function sendMail() {
    setSubmit(true);


    if (/*info && */name && /*validEmail(email) &&*/ validEmail(emailOther)) {

      setSubmitting(true);
      let value = {};

      value["email"] = emailOther;



      value.info = "<a href='https://apps.windrose.echo-cms.be/" + scanResult + "'>" + labels?.["view-online"]?.lang?.[langId]?.name + "</a>";


      const svgElement = document.getElementById('svgElement');
      const svgData = new XMLSerializer().serializeToString(svgElement);
      value.chart = svgData;
      value.name = name;
      value.rapport = rapport;
      value.questions = questions;
      value.account = "wernerdevree";
      value.language = langId;
      value.trap = "";

      value.type = "zelfscan";

      fetch(path + 'form-submit', {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(value), // data can be `string` or {object}!
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())
        .then(response => {

          setSubmit(false);

          if (response.success === true) {
            setSubmitted(true);
            //  formHolder.innerHTML = response.message;
          }
        })
        .catch(error => console.error('Error:', error));


    } else {

    }

  }


  return <div className="info mx-auto">

    {(!submitting &&


      <div>










        <div className="space-y-5 my-5">


          {(true == false &&
            <textarea onChange={(e) => setInfo(e.target.value)} className="w-full border border-black p-5">{info}</textarea>


          )}
          <input placeholder={labels?.["your-name"]?.lang?.[langId]?.name} type="text" onChange={(e) => setName(e.target.value)} className={(submit && !name ? "bg-error " : "") + "w-full border border-black p-5"} value={name} />


          <input placeholder={labels?.["your-email"]?.lang?.[langId]?.name} type="text" onChange={(e) => setEmailOther(e.target.value)} className={(submit && (!emailOther || !validEmail(emailOther)) ? "bg-error " : "") + "w-full border border-black p-5"} value={emailOther} />


          <Button onClick={() => sendMail()}>{labels?.["send"]?.lang?.[langId]?.name}</Button>
        </div>

        <div dangerouslySetInnerHTML={{ __html: blocks?.["zelfscan---signature"]?.lang?.[langId]?.blocks }}></div>




      </div>
    )}

    {(submit &&
      <div className="my-5 text-center flex space-x-3 justify-center items-center">
        <div>
          {labels?.["generating"]?.lang?.[langId]?.name}

        </div>
        <Loader />


      </div>

    )}

    {(submitted &&
      <div className="my-5 text-center"> {labels?.["sending-success"]?.lang?.[langId]?.name}</div>

    )}
  </div>

}

export default Form;
